<template>
  <div class="main-container">
    <div>
      <toast-message
        :message="errmsg"
        :isToastEnable="toast"
        type="error"
        @close="(val) => (toast = val)"
      />
      <div class="modal">
        <div class="modal-content" ref="modalBox">
          <div class="top-bar">
            <img @click="back" src="@/assets/path-2-copy.png" />
            <span class="heading_new">Account Settings</span>
          </div>
          <div class="popup-window-content-no-use">
            <div class="row">
              <div class="block-section-4 col-6">
                <div class="block-section-2">
                  <tl-header type="h3" class="title"> User Account </tl-header>
                  <div class="block-title-icon">
                    <div class="description-text">Change Password</div>
                    <div
                      class="icon-arrow"
                      style="cursor: pointer"
                      @click="openPasswordWindow"
                    >
                      <img src="@/assets/next-icon.png" alt />
                    </div>
                  </div>
                  <!-- <div class="block-title-icon">
                    <div class="description-text">Make Birthday Public</div>
                    <div class="icon-arrow">
                      <img src="@/assets/next-icon.png" alt />
                    </div>
                  </div>
                  <div class="block-title-icon">
                    <div class="description-text">
                      Make Work Anniversary Public
                    </div>
                    <div class="icon-arrow">
                      <img src="@/assets/next-icon.png" alt />
                    </div>
                  </div> -->
                  <!-- <div class="block-title-icon">
                    <div class="description-text">
                      Make Marriage Anniversary Public
                    </div>
                    <div class="icon-arrow">
                      <img src="@/assets/next-icon.png" alt />
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="col-6"></div>
            </div>

            <!-- Another Popup Message show click on Save paln button -->
            <div class="modal-1" v-if="showConfirmationMsg">
              <div class="modal-content-1" ref="modalBox">
                <div class="top-bar-1">
                    <span class="heading_new-1">Change Password</span>
                </div>
                <toast-message
                  :message="passwordErrmsg"
                  :isToastEnable="toastPassword"
                  type="error"
                  @close="(val) => (toastPassword = val)"
                />
                <form action class="form formSection" v-if="instance">
                  <div class="wanring-1" v-if="showerrormsg">
                    <span
                      >New password and confirm New Password should be same</span
                    >
                  </div>
                  <div class="wanring-1" v-if="serverResPopup">
                    <span>
                      Password must have at least one capital letter, <br />one
                      number, one special character and minimum length should
                      be 8
                    </span>
                  </div>
                  <div class="wanring-2" v-if="greenServerPopup">
                    <span>{{ this.serverRes }}</span>
                  </div>
                  <!-- <div class="message-text">
                    Select one of the tax regimes for which you would like to save this plan.
                </div> -->
                  <div class="input-container my-2">
                    <div class="input-label">Current Password</div>
                    <div>
                      <input
                        type="password"
                        v-model="instance.currentPassword"
                        v-validate="{ required: true }"
                        name="changePassword"
                        autocomplete="off"
                        class="inputbox"
                        placeholder="Enter here"
                      />
                      <br />
                    </div>
                  </div>
                  <div class="input-container my-2">
                    <div class="input-label">New Password</div>
                    <div>
                      <input
                        type="password"
                        v-model="instance.newPassword"
                        v-validate="{ required: true }"
                        name="newPassword"
                        autocomplete="off"
                        class="inputbox"
                        placeholder="Enter here"
                      />
                      <br />
                    </div>
                  </div>
                  <div class="input-container my-2">
                    <div class="input-label">Confirm New Password</div>
                    <div>
                      <input
                        type="password"
                        v-model="instance.confirmNewPassword"
                        v-validate="{ required: true }"
                        name="confirmNewPassword"
                        autocomplete="off"
                        class="inputbox"
                        placeholder="Enter here"
                      />
                      <br />
                    </div>
                  </div>
                  <p class="password-text">Your Password must have</p>
                  <p class="password-text-validation">
                    <img src="@/assets/info-2.svg" />Minimum 8 characters
                  </p>
                  <p class="password-text-validation">
                    <img src="@/assets/info-2.svg" />Upper and lowercase letters
                  </p>
                  <p class="password-text-validation">
                    <img src="@/assets/info-2.svg" />At least one number
                  </p>
                  <div class="popup-btns animated fadeIn">
                    <btn-grp>
                      <popup-btn
                        text="Cancel"
                        type="secondary"
                        @click="cancelEvent"
                      />
                      <popup-btn
                        text="Save"
                        type="primary"
                        v-on:click="savePassword"
                      />
                    </btn-grp>
                  </div>
                </form>
              </div>
            </div>
            <!-- End here -->
          </div>
        </div>
      </div>
    </div>

    <pop-up-message
      v-if="showSuccessMsg"
      message="Your password has been successfully change."
      btnText="Back"
      @back="showSuccessMsg=!showSuccessMsg"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      showPopupCompanyPoliciesPopup: false,
      showConfirmationMsg: false,
      instance: {
        identity: "",
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      },
      showerrormsg: false,
      serverRes: "",
      serverResPopup: false,
      greenServerPopup: false,
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      passwordErrmsg: "",
      toastPassword: false
    };
  },
  props: {
    header: {
      type: String,
    },
    btnText: {
      type: String,
    },
    popupType: {
      type: String,
      default: "Success",
    },
    popupHeaderMessage: {
      type: String,
      default: "Success",
    },
    closable: {
      type: Boolean,
      default: false,
    },
    useDefaultHeader: {
      type: Boolean,
      default: true,
    },
    animate: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: true,
    },
    customStyle: {
      type: String,
      default: null,
    },
  },
  mounted() {
    //   if(this.animate) {
    //     this.$root.$el.style.position = "absolute";
    //     this.$root.$el.style.overflow = "hidden";
    //     this.$root.$el.style.height = "100%";
    //   }
  },
  beforeDestroy() {
    //   if(this.animate) {
    //     this.$root.$el.style.position = "static";
    //     this.$root.$el.style.overflow = "visible";
    //     this.$root.$el.style.height = "auto";
    //   }
  },
  computed:{
    ifHR() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
    ifAuditor() {
      return localStorage.getItem("userRole") == "AUDITOR" ? true : false;
    },
  },
  methods: {
    // navigateToDocuments(url){
    //   this.$router.push({
    //     path:url
    // });
    // },
    ...mapActions({
      act_change_password: "auth/changePassword",
    }),

    back() {
      if(this.ifHR || this.ifEmployee) {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/overview`,
        });
      } else if(this.ifAuditor) {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofapproval`,
        });
      } else {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll`,
        });
      }  
    },

    openPasswordWindow() {
      this.showConfirmationMsg = true;
    },

    async validatePassword() {
      if(this.instance.newPassword != "" && this.instance.newPassword != "") {
        if (this.instance.newPassword === this.instance.confirmNewPassword) {
          return true;
        } else {
          this.showerrormsg = true;
          //console.log("new and confirm new password should the same");
        }
      } else {
        return false;
      }
    },
    async savePassword() {
      try {
        this.$root._data.isSaving = true;
        this.greenServerPopup = false;
        //this.serverResPopup = true;
        this.showerrormsg = false;
        let validate = await this.validatePassword();
        if (validate == true) {
          let res = await this.act_change_password(this.instance);
          
          if (res.data.statusCode == 200 || res.data.statusCode === 201) {
            this.greenServerPopup = true;
            this.showConfirmationMsg = false;
            this.showSuccessMsg = true;
            this.serverResPopup = false;
            this.resetForm();
          }
        } else {
          this.serverResPopup = true;
        }
        this.$root._data.isSaving = false;
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toastPassword = true;
        this.passwordErrmsg = err;
      }
    },
    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
      this.showerrormsg = false;
      this.resetForm();
      this.serverResPopup = false;
      this.greenServerPopup = false;
    },

    resetForm() {
      this.instance = {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: ""
      }
    }
  },
};
</script>


<style lang="scss" scoped>
.main-container {
  width: 100%;
  padding: 0px 0 0 0px;
  margin-bottom: 110px;
}

.block-section-4 {
  margin: 30px;
  padding: 0px;
  background: white;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex: 1;
  flex: 1;
  height: auto;
  border: 2px solid #eeeeee;
  border-radius: 8px;
  -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}

.block-title-icon {
  margin: 20px 0px;
}

.description-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #5d409f;
  margin-left: 30px;
  width: 45%;
}

.icon-arrow {
  float: right;
  margin-right: 32px;
  transform: translate(0px, -18px);
}

.icon-arrow > img {
  height: 10px;
}

.title {
  padding: 20px;
}

.top-bar {
  height: 64px;
  width: 100%;
  //border-radius: 12px 12px 0px 0px;
  //display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

@keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  60% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 120px;
  }
}
@-webkit-keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  60% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 120px;
  }
}
.animated {
  animation-duration: 0.4s !important;
  animation-iteration-count: 1 !important;
  animation-timing-function: ease-in !important;
  -webkit-animation-duration: 0.4s !important;
  -webkit-animation-iteration-count: 1 !important;
  -webkit-animation-timing-function: ease-in !important;
}
.fadeInUp {
  -webkit-animation-name: fadeInUp !important;
  animation-name: fadeInUp !important;
}

.modal {
  //   display: block;
  //   position: fixed;
  //   z-index: 6;
  //   left: 0px;
  //   top: 0px;
  width: 100%;
  height: 100%;
  //  overflow: hidden;
}

// .modalbg {
//   background: rgba(0, 0, 0, 0.60);
//   -webkit-backdrop-filter: blur(14px);
//   backdrop-filter: blur(10px);
// }

/* Modal Content */

.modal-content {
  //   background-color: white;
  //   margin: 120px auto 0px auto;
  //   z-index: 20;
  //   width: 80%;
  //   height: calc(100% - 120px);
  //   display: flex;
  //   flex-direction: column;
  //   align-items: flex-start;
  //   border-radius: 12px 12px 0px 0px;
  //   opacity: 1;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    margin-bottom: 40px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete {
    display: flex;
    align-items: center;
    *:nth-child(n) {
      margin-right: 20px;
    }
  }

  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
  }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}

.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  40% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}
@-webkit-keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  40% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
    margin-top: 110px;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown !important;
  animation-name: fadeOutDown !important;
}

// Modal popup code start here
.modal-1 {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background-color: rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px);
}

/* Modal Content */

.modal-content-1 {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 30%;
  min-width: 350px;
  // width: 30%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  //opacity: 0;
  //padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text-1 {
    margin-bottom: 20px;
    line-height: 25px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete {
    display: flex;
    align-items: center;
    *:nth-child(n) {
      margin-right: 20px;
    }
  }
  .warning {
    margin-bottom: 16px;
    text-align: center;
    height: 24px;
    width: 24px;
  }
  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
  }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: #34c0be solid 2px;
    color: #34c0be;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}
.success-img {
  position: relative;
  height: 24px;
  width: 24px;
  &.animated {
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: pulse;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}

.top-bar-1 {
  height: 64px;
  width: 100%;
  //width: 378px;
  //transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
}

.formSection{
  padding: 30px;
}

.heading_new-1 {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}
.wanring-1 {
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #e72424;
}
.wanring-2 {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #31d31c;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }
}

.inputbox {
  width: 300px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

.password-text {
  font-weight: 600;
  font-size: 15px;
  margin: 20px 0px;
}

.password-text-validation > img {
  margin-right: 15px;
  transform: translate(5px, 5px);
}
</style>

